import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Register() {
  const [email, setEmail]       = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm]   = useState('')
  const [error, setError]       = useState('')
  const [success, setSuccess]   = useState(false)
  const [loading, setLoading]   = useState(false)

  const handleRegister = async (e) => {
    e.preventDefault()
    setError('')
    if (password !== confirm) { setError('Passwords do not match.'); return }
    if (password.length < 8)  { setError('Password must be at least 8 characters.'); return }
    setLoading(true)
    const { error } = await supabase.auth.signUp({ email, password })
    if (error) setError(error.message)
    else setSuccess(true)
    setLoading(false)
  }

  return (
    <div className="auth-layout">
      <div className="auth-panel">
        <div className="auth-panel-content">
          <div className="auth-logo">
            <div className="auth-logo-mark">↑</div>
            <span className="auth-logo-name">Uplift</span>
          </div>
          <h1>Register once, update anytime</h1>
          <p>Create your free account in under a minute. Your information is kept private and you can update it whenever you need to.</p>
          <div className="auth-panel-features">
            <div className="auth-feature">
              <div className="auth-feature-icon">⚡</div>
              Quick one-time registration
            </div>
            <div className="auth-feature">
              <div className="auth-feature-icon">🔐</div>
              Only you can see your data
            </div>
            <div className="auth-feature">
              <div className="auth-feature-icon">📱</div>
              Works on any device
            </div>
          </div>
        </div>
      </div>

      <div className="auth-form-side">
        <div className="auth-card">
          <div className="auth-card-logo">
            <div className="auth-card-logo-mark">↑</div>
            <span className="auth-card-logo-name">Uplift</span>
          </div>
          <h2>Create your account</h2>
          <p className="subtitle">It only takes a minute</p>

          {error && <div className="alert alert-error">⚠ {error}</div>}

          {success ? (
            <div className="alert alert-success">
              ✓ Account created! Check your email to confirm, then <Link to="/login">sign in here</Link>.
            </div>
          ) : (
            <form onSubmit={handleRegister}>
              <div className="form-group">
                <label>Email address</label>
                <input
                  type="email" required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  autoComplete="email"
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  type="password" required
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="At least 8 characters"
                  autoComplete="new-password"
                />
              </div>
              <div className="form-group">
                <label>Confirm password</label>
                <input
                  type="password" required
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  placeholder="Repeat your password"
                  autoComplete="new-password"
                />
              </div>
              <button className="btn btn-primary" type="submit" disabled={loading}>
                {loading ? 'Creating account…' : 'Create account →'}
              </button>
            </form>
          )}

          <div className="auth-link">
            Already have an account? <Link to="/login">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  )
}
